import { Outlet } from 'react-router-dom';
import { Logo } from '@/components/logo';

/**
 * Deliberately plain. Everything the visitor needs to do is in one column, and
 * the value proposition sits underneath rather than competing with the form.
 */
export const AuthLayout = () => (
  <div className="flex min-h-svh flex-col items-center justify-center px-4 py-12">
    <div className="w-full max-w-sm">
      <div className="mb-8 flex justify-center">
        <Logo />
      </div>

      <Outlet />

      <p className="mt-8 text-center text-xs leading-relaxed text-ink-subtle">
        GainSignal detects revenue changes, investigates the cause, and tells
        you what to do next.
      </p>
    </div>
  </div>
);
